import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Gesture, GestureController, Platform } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { Clipboard } from '@capacitor/clipboard';
import { PopoverAndToastService } from './popover-and-toast.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Manages state of the context menu for a single message
 */
export class MessageContextService {
  constructor(
    private gestureCtrl: GestureController,
    private router: Router,
    private platform: Platform,
    private patService: PopoverAndToastService
  ) {
    this.router.events
      .pipe(filter((r) => r instanceof NavigationEnd))
      .subscribe((r) => {
        if (
          !(r as NavigationEnd).url.includes('/conversations/') &&
          this.heldPress
        ) {
          this.removeHeldPress();
        }
      });
  }

  //Gesture variables.
  private longPressMessageGesture: Gesture;
  heldPress = false;
  holdingPress = false;
  /**
   * The single message which was long-pressed
   */
  public heldMessage: any = null;
  // Gesture Code
  public setupHoldPress(messageBubblesArray) {
    for (let message of messageBubblesArray) {
      this.longPressMessageGesture = this.gestureCtrl.create(
        {
          el: message.nativeElement,
          threshold: 0,
          gestureName: 'long-press',
          onStart: (ev) => {
            this.holdingPress = true;
            this.useHoldPress(ev, message);
          },
          onEnd: (end) => {
            this.holdingPress = false;
          },
        },
        true
      );
      this.longPressMessageGesture.enable();
    }
  }
  private useHoldPress(ev, msg) {
    setTimeout(async () => {
      if (this.holdingPress) {
        if (this.heldMessage != null) {
          //Removes the previoues heldMessage background before setting the new one.
          this.heldMessage.style.removeProperty('background');
        }
        this.heldMessage = msg.nativeElement;
        this.heldMessage.id = msg.nativeElement.childNodes[0].innerHTML;
        this.heldMessage.send_status =
          msg.nativeElement.childNodes[1].innerHTML;
        this.heldMessage.style.setProperty('background', '#537a8a');

        this.heldPress = true;

        if (this.platform.is("ios")) {
          await this.patService.presentIOSMessagePopover(ev.event, this.heldMessage);
          this.removeHeldPress();
        }
      }
    }, 500);
  }
  /**
   * 
   */
  public removeHeldPress() {
    this.heldMessage.style.removeProperty('background');
    this.heldMessage = null;
    this.heldPress = false;
  }
  theClipboard = navigator.clipboard;

  /**
   * Copies the body of the message from the current context.
   */
  public copyText() {
    Clipboard
      .write({
        string: this.heldMessage.childNodes[2].innerHTML
      })
      .then(async (res) => {
        const toast = await this.patService.presentToast({
          message: 'Copied!',
          duration: 200,
          position: 'top',
          color: 'success',
        });
        this.removeHeldPress();
      })
      .catch(async (err) => {
        const toast =  await this.patService.presentToast({
          message: 'Failed to copy! - ' + err,
          duration: 200,
          position: 'top',
          color: 'danger',
        });
        this.removeHeldPress();
        console.log(err);
      });
  }
 
}
